export class AddressDto {
  constructor(d?: AddressDto) {
    Object.assign(this, d || {});
  }
}
